import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, NavigationStart, Route, Router, RouterOutlet } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { setTranslocoService } from './model/message.constant';
import { FuseLoadingService } from '@fuse/services/loading';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import Gleap from 'gleap';
Gleap.initialize('nLTao49nVlJMj1nVYIgbg74IgZi9lM9T');

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor(
        private translocoService: TranslocoService, 
        private router: Router,
        private fuseLoadingService: FuseLoadingService,
        private fuseSplashScreenService: FuseSplashScreenService
    ) {
        setTranslocoService(this.translocoService); // Initialize Transloco for messages
    }

    ngOnInit(): void {
        // Show loading bar and splash screen on navigation
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                // Show loading bar on navigation start
                this.fuseLoadingService.show();
            }
            
            if (event instanceof NavigationEnd) {
                // Hide loading bar on navigation end
                this.fuseLoadingService.hide();
                // Ensure splash screen is removed on every route change
                this.fuseSplashScreenService.hide();
                
                const currentUrl = event.urlAfterRedirects;

                if (currentUrl.includes('/report-view')) {
                   Gleap.setDisablePageTracking(true);
                   console.log('page tracking disabled');
                } else {
                  Gleap.setDisablePageTracking(false);
                  console.log('page tracking enabled');
                }
            }
        });
    }
}
